module.exports = __webpack_public_path__ + "media/images/menu-ef356384dc808f3379b610a33136dc60.svg";